import React, { useRef, useState } from "react";
import { Form, Input, Image } from "antd";
import EyeOpen from "../../../../assets/images/eye-open.svg";
import EyeClose from "../../../../assets/images/eye-close.svg";
import { LockFilled, MailOutlined } from "@ant-design/icons";

const CustomInput = ({ addon, label, name, type, placeholder, rules,onChange }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const togglePasswordVisibility = () => {
    const { selectionStart, selectionEnd } = inputRef.current.input;
    setPasswordVisible(!passwordVisible);
    setTimeout(() => {
      inputRef.current.input.setSelectionRange(selectionStart, selectionEnd);
      inputRef.current.focus();
    }, 0);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    e.target.value && onChange(e)
  };

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Input
        ref={inputRef}
        type={passwordVisible ? "text" : type}
        placeholder={placeholder}
      
        value={inputValue}
        onChange={handleInputChange}
        suffix={
          type === "password" &&
          (passwordVisible ? (
            <Image
              preview={false}
              src={EyeOpen}
              alt="Eye Open"
              onClick={togglePasswordVisibility}
            />
          ) : (
            <Image
              preview={false}
              src={EyeClose}
              alt="Eye Close"
              onClick={togglePasswordVisibility}
            />
          ))
        }
      />
    </Form.Item>
  );
};

export default CustomInput;
